<template lang="pug">
  .page
    section
      .max-width
        .row.vertical.center
          .col
            .logo-wrapper
              img.logo(src="../../assets/images/logo-white-text.svg")
          .col
            .form-wrapper
              form(@submit.prevent="submit")

                h1.primary-text Join {{company.name}}

                AlertBox(v-if="error", type="danger", :text="error")

                div.form-field(:class="{error: $v.form.firstName.$error, 'error-required': !$v.form.firstName.required}")
                  label
                    input(placeholder="First Name", minlength="2", maxlength="25", type="text", v-model="$v.form.firstName.$model")

                div.form-field(:class="{error: $v.form.lastName.$error, 'error-required': !$v.form.lastName.required}")
                  label
                    input(placeholder="Last Name", minlength="2", maxlength="25", type="text", v-model="$v.form.lastName.$model")

                div.form-field(:class="{error: $v.form.email.$error, 'error-required': !$v.form.email.required}")
                  label
                    input(placeholder="Work Email Address", v-model="$v.form.email.$model", type="email")

                div.form-field(:class="{error: $v.form.password.$error, 'error-required': !$v.form.password.required}")
                  label
                    input(placeholder="Password", minlength="8", v-model="$v.form.password.$model", type="password")

                div.form-field
                  button.button.primary-button(type="submit") Submit
</template>

<script>

import { mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Verify',
  data () {
    return {
      error: null,
      company: {
        name: ''
      },
      form: {
        firstName: '',
        lastName: '',
        email: '',
        password: ''
      }
    }
  },
  validations: {
    form: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      email: {
        required
      },
      password: {
        required
      }
    }
  },
  beforeMount () {
    if (this.$route.params.token) {
      this.$store.dispatch('getInvite', {
        token: this.$route.params.token
      }).then(company => {
        this.company = company
        //this.$router.push({name: 'Dashboard'}).catch(err => {})
      })
    }
  },
  computed: {
    ...mapState({
      company: state => state.company
    })
  },
  methods: {
    submit () {
      let data = {
        token: this.$route.params.token,
        form: this.form
      }
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('invalid')
      } else {
        this.$store.dispatch('postInvite', data).then(() => {
          this.$router.push({ name: 'Verify' })
        }, errors => {
          this.error = error.error
          //console.log(errors)
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.page
  margin 0 auto

.logo-wrapper
  margin-bottom 60px
  text-align center
  img
    max-width 521px
    +for_breakpoint(mobile)
      max-width 100%

.form-wrapper
  background-color #fff
  border-radius $border-radius
  margin-left $spacing-3
  padding $spacing-3
  width 400px
  +for_breakpoint(mobile)
    width auto

  h1
    font-size 22px
    text-align center
    margin-bottom 40px

  form
    margin 0 auto
    //max-width 400px

</style>
